import {
  getActivationFlowData,
  saveActivationFlowData,
} from "app/pages/Customer/FixedPhone/Checkout/utils/fixed-phone-storage";

function digitsOnly(value: string): string {
  return (value || "").replace(/\D/g, "").trim();
}

export function buildPreloadedSimDeviceFingerprint(
  simDigits: string,
  imeiDigits: string,
): string {
  return `${digitsOnly(simDigits)}|${digitsOnly(imeiDigits)}`;
}

export function hasPreloadedSimIncludedPlan(simData: unknown): boolean {
  if (!simData || typeof simData !== "object") {
    return false;
  }
  const data = simData as Record<string, unknown>;
  const included = data.planIncluded;
  if (!included || typeof included !== "object") {
    return false;
  }
  const planFrequencyRaw = Number.parseInt(
    String((included as Record<string, unknown>).frequency ?? ""),
    10,
  );
  return Number.isFinite(planFrequencyRaw) && [1, 3, 6, 12].includes(planFrequencyRaw);
}

export function doesPreloadedSimDeviceMatchCommittedFingerprint(params: {
  simDigits: string;
  imeiDigits: string;
  committedFingerprint: string | undefined | null;
}): boolean {
  const committed = String(params.committedFingerprint || "").trim();
  if (!committed) return false;
  const next = buildPreloadedSimDeviceFingerprint(params.simDigits, params.imeiDigits);
  return next === committed;
}

export function clearPreloadedSimSecuritySelectionInSession(): void {
  saveActivationFlowData({
    optForSecurityPlan: undefined,
    securityPlanId: undefined,
  });
}

export function clearPreloadedSimChoosePlanAndSecurityInSession(): void {
  saveActivationFlowData({
    preloadedSimInventoryDevice: undefined,
    preloadedSimPrimaryDataTier: undefined,
    preloadedSimServiceFrequency: undefined,
    preloadedSimPlanId: undefined,
    preloadedSimOptedForDataOrFrequencyUpsell: undefined,
    preloadedSimUpgradeCardDraft: undefined,
    optForSecurityPlan: undefined,
    securityPlanId: undefined,
  });
}

/**
 * When SIM/IMEI no longer match the last committed device (post–inventory success),
 * clear choose-plan + security so later steps are not reused with stale SIM context.
 */
export function maybeResetPreloadedSimAfterCommittedDeviceEdited(
  currentSimDigits: string,
  currentImeiDigits: string,
): void {
  const act = getActivationFlowData();
  const committed = (act?.preloadedSimDeviceCommitFingerprint || "").trim();
  if (!committed) return;
  const next = buildPreloadedSimDeviceFingerprint(
    currentSimDigits,
    currentImeiDigits,
  );
  if (next === committed) return;
  clearPreloadedSimChoosePlanAndSecurityInSession();
}
